import activityAbTest from './zh-CN/activityAbTest';
import activityAuto from './zh-CN/activityAuto';
import activityCycle from './zh-CN/activityCycle';
import activityManage from './zh-CN/activityManage';
import activityReport from './zh-CN/activityReport';
import activityWhatsApp from './zh-CN/activityWhatsApp';
import adminManage from './zh-CN/adminManage';
import apiErrorCode from './zh-CN/apiErrorCode';
import businessManage from './zh-CN/businessManage';
import common from './zh-CN/common';
import components from './zh-CN/components';
import contactManage from './zh-CN/contactManage';
import contactReport from './zh-CN/contactReport';
import countryConfig from './zh-CN/countryConfig';
import dataReport from './zh-CN/dataReport';
import home from './zh-CN/home';
import labelManage from './zh-CN/labelManage';
import languageConfig from './zh-CN/languageConfig';
import placeholderManage from './zh-CN/placeholderManage';
import preferenceManage from './zh-CN/preferenceManage';
import segmentsManage from './zh-CN/segmentsManage';
import settingManage from './zh-CN/settingManage';
import templateManage from './zh-CN/templateManage';
import testerManage from './zh-CN/testerManage';
import userJourney from './zh-CN/userJourney';
import whatsAppTemplate from './zh-CN/whatsAppTemplate';
import exportCenter from './zh-CN/exportCenter';

export default {
  ...apiErrorCode,
  ...common,
  ...components,
  ...countryConfig,
  ...languageConfig,
  ...adminManage,
  ...businessManage,
  ...settingManage,
  ...home,
  ...activityManage,
  ...activityCycle,
  ...activityAbTest,
  ...activityAuto,
  ...userJourney,
  ...contactManage,
  ...segmentsManage,
  ...labelManage,
  ...preferenceManage,
  ...templateManage,
  ...placeholderManage,
  ...dataReport,
  ...activityReport,
  ...contactReport,
  ...activityWhatsApp,
  ...whatsAppTemplate,
  ...testerManage,
  ...exportCenter,
};
